export enum AGENT_HUB_AGENTS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791543640
     */

    ADD_STARTER = 'AGENT_HUB_SEARCH.ADD_STARTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792065777
     */
    AGENT_TYPE_DESCRIPTION = 'AGENT_HUB_SEARCH.AGENT_TYPE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=823569316
     */
    AI_AGENTS = 'AGENT_HUB_SEARCH.AI_AGENTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=823569826
     */
    AI_SEARCH_ASSISTANTS = 'AGENT_HUB_SEARCH.AI_SEARCH_ASSISTANTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791550512
     */
    CONVERSATION_STARTER_DELETE_CONFIRM = 'AGENT_HUB_SEARCH.CONVERSATION_STARTER_DELETE_CONFIRM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791543490
     */
    CONVERSATION_STARTER_LABEL = 'AGENT_HUB_SEARCH.CONVERSATION_STARTER_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791543306
     */
    CONVERSATION_STARTERS = 'AGENT_HUB_SEARCH.CONVERSATION_STARTERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791543371
     */
    CONVERSATION_STARTERS_DESCRIPTION = 'AGENT_HUB_SEARCH.CONVERSATION_STARTERS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=745437122
     */
    CUSTOM_MESSAGE_DESCRIPTION = 'AGENT_HUB_SEARCH.CUSTOM_MESSAGE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744792080
     */
    EXPERTISE_TITLE_HELPER = 'AGENT_HUB_SEARCH.EXPERTISE_TITLE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=794612696
     */
    EXTERNAL_AGENT_HOW_IT_WORKS_FIRST_INFO = 'AGENT_HUB_SEARCH.EXTERNAL_AGENT_HOW_IT_WORKS_FIRST_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=794612775
     */
    EXTERNAL_AGENT_HOW_IT_WORKS_SECOND_INFO = 'AGENT_HUB_SEARCH.EXTERNAL_AGENT_HOW_IT_WORKS_SECOND_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=793418211
     */
    EXTERNAL_LINK_HELPER = 'AGENT_HUB_SEARCH.EXTERNAL_LINK_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=848058880
     */
    NATIVE_AGENT_INFO = 'AGENT_HUB_SEARCH.NATIVE_AGENT_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792097099
     */
    PROMPT_PLACEHOLDER = 'AGENT_HUB_SEARCH.PROMPT_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=740811383
     */
    PROVIDE_CUSTOM_ANSWER = 'AGENT_HUB_SEARCH.PROVIDE_CUSTOM_ANSWER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792097260
     */
    SYSTEM_PROMPT = 'AGENT_HUB_SEARCH.SYSTEM_PROMPT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=856731875
     */
    TOO_MANY_TOOLS_WARNING = 'AGENT_HUB_AGENTS.TOO_MANY_TOOLS_WARNING',
}
